var url = location.href;
/*var url_static = "https://invicta.com.pe/";
var url_static_product = "https://invicta.com.pe//collections/relojes-en-oferta";
var url_static_product2 = "https://invicta.com.pe//collections/relojes-para-hombre";
var url_static_product3 = "https://invicta.com.pe//collections/relojes-para-mujer";*/

/* if(url == url_static && localStorage.getItem("subscription") == undefined && sessionStorage.getItem("subscription") == undefined){
 	$("#modalNewsletter").css("display", "flex");
 }*/
/*
setTimeout(function(){
    if(url == url_static && localStorage.getItem("subscription") == undefined && sessionStorage.getItem("subscription") == undefined){
    	$("#modalNewsletter").css("display", "flex");
    }
}, 50000);

setTimeout(function(){
    if(url == url_static_product && localStorage.getItem("subscription_product") == undefined && sessionStorage.getItem("subscription_product") == undefined){
    	$("#modalNewsletter").css("display", "flex");
    }
}, 50000);

setTimeout(function(){
    if(url == url_static_product2 && localStorage.getItem("subscription_product2") == undefined && sessionStorage.getItem("subscription_product2") == undefined){
    	$("#modalNewsletter").css("display", "flex");
    }
}, 50000);

setTimeout(function(){
    if(url == url_static_product3 && localStorage.getItem("subscription_product3") == undefined && sessionStorage.getItem("subscription_product3") == undefined){
    	$("#modalNewsletter").css("display", "flex");
    }
}, 50000);

if(url == url_static+"?customer_posted=true#contact_form"){
	$("#modalSuccess").css("display", "flex");
    localStorage.setItem("subscription", "yes");
    localStorage.setItem("subscription_product", "yes");
    localStorage.setItem("subscription_product2", "yes");
    localStorage.setItem("subscription_product3", "yes");
}

if(url == url_static+"?contact%5Btags%5D=newsletter&form_type=customer#ContactFooter" || url == url_static+'?contact%5Baccepts_marketing%5D=on&contact%5Btags%5D=newsletter&form_type=customer#contact_form' || url == url_static+'?contact%5Btags%5D=newsletter&form_type=customer#contact_form'){
	$("#modalError").css("display", "flex");
    localStorage.setItem("subscription", "yes");
    localStorage.setItem("subscription_product", "yes");
    localStorage.setItem("subscription_product2", "yes");
    localStorage.setItem("subscription_product3", "yes");
}

$('.modal-dialog').click(function (e) {
    e.stopPropagation();
});

$("#modalNewsletter").click(function() {
    $("#modalNewsletter").css("display", "none");
});

$("#btn-subscription-modal").click(function(){
	$("#modalNewsletter").css("display", "none");
});

$("#modalError").click(function() {
    $("#modalError").css("display", "none");
  	location.href= url_static;
});

$("#modalSuccess").click(function() {
    $("#modalSuccess").css("display", "none");
    if(url == url_static){
      localStorage.setItem("subscription", "yes");
    }else if(url == url_static_product){
      localStorage.setItem("subscription_product", "yes");
    }else if(url == url_static_product2){
      localStorage.setItem("subscription_product2", "yes");
    }else if(url == url_static_product3){
      localStorage.setItem("subscription_product3", "yes");
    }
  	location.href=url_static;
});

$("#omitir").click(function() {
    $("#modalNewsletter").css("display", "none");

  if(url == url_static){
    localStorage.setItem("subscription", "yes");
  }else if(url == url_static_product){
    localStorage.setItem("subscription_product", "yes");
  }else if(url == url_static_product2){
    localStorage.setItem("subscription_product2", "yes");
  }else if(url == url_static_product3){
    localStorage.setItem("subscription_product3", "yes");
  }
});

$("#btn-success-modal").click(function(){
	$("#modalSuccess").css("display", "none");

    if(url == url_static){
      localStorage.setItem("subscription", "yes");
    }else if(url == url_static_product){
      localStorage.setItem("subscription_product", "yes");
    }else if(url == url_static_product2){
      localStorage.setItem("subscription_product2", "yes");
    }else if(url == url_static_product3){
      localStorage.setItem("subscription_product3", "yes");
    }
  
  	location.href=url_static;
});

$("#btn-error-modal").click(function(){
	$("#modalError").css("display", "none");
  	location.href=url_static;
});

$("#carouselExampleIndicators").mouseover(function(){
  $(".carousel-control-prev").attr("style", "display: flex !important");
  $(".carousel-control-next").attr("style", "display: flex !important");
});

$("#carouselExampleIndicators").mouseleave(function(){
  $(".carousel-control-prev").attr("style", "display: none !important");
  $(".carousel-control-next").attr("style", "display: none !important");
});
*/